import C from '../../../constants/accounting/payable/historyPreviewSupplierOversea';
import accountingServices from "../../../services/accountingServices";

export const activeScreenPreviewOversea = () => dispatch => {
    dispatch({type: C.ACTIVE_SCREEN_STATUS, payload: true})
}

export const getInvoiceSupplierOverseaView = (id) => dispatch => {
    accountingServices.getInvoiceSupplierOversea(id).then(res => {
        if(res.success) {
            dispatch({type: C.CHANGE_INVOICE_DETAIL, payload: res.data})
        }
    })
}

export const resetData = () => dispatch => {
    dispatch({type: C.RESET_DATA})
}